import { useMutation } from "@apollo/client"
import { useLocalStorage } from "@mantine/hooks"
import CustomButton from "components/Atoms/CustomButton"
import NumberInput from "components/Common/NumberInput"
import StatefulForm from "components/Organisms/StatefulForm"
import { AGENT_LOGIN } from "graphql/kite.graphql"
import loginModel from "models/login.model"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import clsx from "utils/clsx"
import { graphqlError } from "utils/parseError"
export default function LoginForm() {
  const navigate = useNavigate()
  const [token, setToken] = useLocalStorage({ key: "token" })
  const [, setOrganisation] = useLocalStorage({
    key: "organisation",
  })
  useEffect(() => {
    if (token) return navigate("/d")
  }, [token, navigate])
  const [login, { loading }] = useMutation(AGENT_LOGIN, {
    onCompleted({ agent_login }) {
      if (!agent_login) return
      const agent = agent_login.me.agent
      const token = agent_login.token
      AppToaster.show({
        icon: "tick",
        message: `Logged in as ${agent.name} (${agent.eid}) for ${agent.organisation.name}`,
        intent: "success",
      })
      setToken(token)
      setOrganisation(agent.organisation.uid)
      window.location.pathname = "/d"
    },
    onError(err) {
      setToken(null)
      setOrganisation(null)
      AppToaster.show({
        message: graphqlError(err.message),
        intent: "danger",
      })
    },
  })

  function handleSubmit(state, errors) {
    if (errors.latest) {
      return AppToaster.show({
        message: errors.latest,
        intent: "danger",
        icon: "cross",
      })
    }
    login({ variables: state, context: { client: "kite" } })
  }

  return (
    <StatefulForm
      className="vt-login-stateful-form"
      initialState={{}}
      schema={loginModel}
      onSubmit={handleSubmit}
    >
      <NumberInput
        data-testid="username"
        id="username"
        className="vt-login-username-input"
        label="Employee ID"
        path="username"
      />
      <NumberInput
        data-testid="password"
        id="password"
        className="vt-login-password-input mb-6"
        type="password"
        label="Password"
        path="password"
      />
      <CustomButton
        pill
        data-testid="submit"
        className={clsx("vt-login-button")}
        dark
        loading={loading}
        text="Login"
        type="submit"
      />
    </StatefulForm>
  )
}
